import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Etapa } from 'src/app/models/etapa';
import { EtapaPedido } from 'src/app/models/etapa-pedido';
import { CarregandoService } from 'src/app/services/carregando.service';
import { EtapaService } from 'src/app/services/etapa.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';

@Component({
  selector: 'app-selecionar-etapa-pedido-modal',
  templateUrl: './selecionar-etapa-pedido-modal.component.html',
  styleUrls: ['./selecionar-etapa-pedido-modal.component.scss']
})
export class SelecionarEtapaPedidoModalComponent implements OnInit {
  public config: PerfectScrollbarConfigInterface = {};
  idCupom: any;
  idEtapa: any;

  etapas: Etapa[] = [];

  carregando = true;
  tipo = 0;
  constructor(
    private etapaService: EtapaService,
    public dialogRef: MatDialogRef<SelecionarEtapaPedidoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
  ) {

    this.idCupom = data.idCupom;
    this.idEtapa = data.idEtapa;


  }

  ngOnInit(): void {
    this.buscarEtapas();
  }



  selecionarEtapa(idEtapa) {
    this.carregandoService.mostra('salvarEtapa');
    this.carregando = true;

    const historico = new EtapaPedido();
    historico.idCupom = this.idCupom;
    historico.idEtapa = idEtapa;

    this.etapaService.salvarHistoricoSimples(historico).subscribe((data: any) => {
      this.dialogRef.close(idEtapa);
      this.carregando = false;
      this.carregandoService.esconde('salvarEtapa');
    }, (erro) => {
      this.carregandoService.esconde('salvarEtapa');
      this.notificacaoService.erro(erro);
    });
  }

  buscarEtapas() {
    this.carregandoService.mostra('buscarEtapas');
    this.carregando = true;
    this.etapaService.consultarParaEscolher().subscribe((data: any) => {
      this.etapas = data;
      this.carregando = false;
      this.carregandoService.esconde('buscarEtapas');
    }, (erro) => {
      this.carregandoService.esconde('buscarEtapas');
      this.notificacaoService.erro(erro);
    });
  }

}
